<script setup lang="ts">
import { TheNavbar, TheSnackbar, TheFooter } from '@/components';

const route = useRoute();

const showNavbar = computed((): boolean => {
  if (['showcase'].includes(route.name.split('-')[0])) {
    return false;
  }

  return true;
});
</script>

<template>
  <v-layout>
    <TheNavbar v-if="showNavbar" />
    <v-main>
      <div class="app-page">
        <NuxtPage />
      </div>
      <TheSnackbar />
    </v-main>
  </v-layout>
</template>

<style lang="scss" scoped>
@use 'vuetify/settings' as *;
@use 'sass:map';
@use '#core/assets/scss/partials/colors' as *;

.v-main {
  padding-top: 72px !important; // Account for fixed navbar height
  background: linear-gradient(135deg, $background-primary 0%, $background-secondary 100%) !important;
  min-height: 100vh;
}
</style>
